var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"share-qrcode-container"},[_c('div',{staticClass:"close-btn",on:{"click":_vm.closeQrcode}},[_c('i',{staticClass:"el-icon-close"})]),_c('div',{staticClass:"qrcode-content"},[_c('div',{staticClass:"qrcode-wrapper"},[_c('div',{ref:"qrCodeDiv"}),_c('div',{staticClass:"qrcode-tip"},[_vm._v("手机扫码查看")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }